import React, { FC, useEffect, useState } from 'react';
import './ExportButtons.scss';
import Swal from 'sweetalert2';

interface ExportButtonsProps {
    getExcel?: () => void;
    getPdf?: () => void;
    isLoading?: boolean;
    error?: string;
}

const ExportButtons: FC<ExportButtonsProps> = ({ getExcel, getPdf, isLoading, error = '' }: ExportButtonsProps) => {
    useEffect(() => {
        if(isLoading) {
            Swal.fire({
                title: "<p class='title-swal m-0'>Solicitando Relatório<br/>Aguarde que avisaremos<br/>quando tudo estiver pronto.</p>",
                allowOutsideClick: false
            });
            Swal.showLoading();
        } else {
            if(error) {
                Swal.fire(`<p class='title-swal m-0'>${error}</p>`);
                Swal.hideLoading();
            } else {
                Swal.close();
            }
        }
    }, [isLoading]);

    return (
        <div className="ExportButtons" data-testid="ExportButtons">
            <div className="btn-group">
                {getExcel && (
                    <button className="icon bg-gradient-success text-white rounded" disabled={isLoading}
                        onClick={getExcel}>
                        <i className="fas fa-file-excel" />
                    </button>
                )}

                {getPdf && (
                    <button className="icon bg-danger text-white rounded" disabled={isLoading} onClick={getPdf}>
                        <i className="fas fa-file-pdf" />
                    </button>
                )}
            </div>
        </div>
    );
}

export default ExportButtons;
